import { useContext } from "react";
import { HostServiceContext } from "@liberty-fund/utils/hostServices";

export const useHostServices = () => useContext(HostServiceContext);
